<mat-dialog-content class="px-6 py-4">
  <app-upload-file #uploadComponent [config]="uploadConfig" />
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancelar</button>
  <button mat-flat-button color="accent" (click)="onSave()" [disabled]="!isValid()">Guardar</button>
</mat-dialog-actions>
